<template>
  <div
    :id="computedId"
    class="tw:transition-all tw:duration-300 tw:ease-in-out tw:overflow-hidden"
    :class="{ 'tw:hidden!': !visible }"
  >
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = defineProps<{
  id?: string
  visible: boolean
}>()

const computedId = computed(() => {
  return props.id ? props.id : `collapse-play-${Math.random().toString(36).substr(2, 9)}`
})
</script>
